function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getChinaLocalization } from 'shared/account/reducer';
import featureEnabled from 'shared/helper/feature';
import PreferredGroupWidget from 'researcher/dashboard/components/PreferredGroupWidget';
import IdentifyPage from 'researcher/application/components/IdentifyPage';
import { T, useTranslate } from 'shared/helper/translate';
import Link from 'shared/components/Link';
import { removePreferredGroup, addPreferredGroup } from '../actions';
import OptionCard from '../components/OptionCard';
import ModalError from '../components/ModalError';
import RubriqNotificationBox from '../components/RubriqNotificationBox';
import PlanPagePaymentRecoveryBanner from '../components/PlanPagePaymentRecoveryBanner';
import PageSection from '../components/PageSection';
import RubriqBillingHistory from './RubriqBillingHistory';
import PhasingOutAvailablePlans from './PhasingOutAvailablePlans';
import PlanCard from './PlanCard';
import ChinaPricingPage from './pricing/china/ChinaPricingPage';
import RowPricingPage from './pricing/row/RowPricingPage';
var Subscriptions = function Subscriptions(_ref) {
  var _curieSubscription$pl, _curieSubscription$pl2, _curieSubscription$pl3, _curieSubscription$pl4;
  var showPlans = _ref.showPlans;
  var _useSelector = useSelector(function (state) {
      return state;
    }),
    user = _useSelector.user,
    application = _useSelector.application,
    curieSubscription = _useSelector.curie;
  var dispatch = useDispatch();
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var inPreferredGroupOnly = ((_curieSubscription$pl = curieSubscription.plans) === null || _curieSubscription$pl === void 0 ? void 0 : _curieSubscription$pl.preferred_group) && !((_curieSubscription$pl2 = curieSubscription.plans) !== null && _curieSubscription$pl2 !== void 0 && _curieSubscription$pl2.premium);
  var chinaLocalization = useSelector(getChinaLocalization);
  var newRowPlans = featureEnabled('rubriq_show_repriced_and_renamed_plans_for_row');
  var paddleBillingForChina = featureEnabled('rubriq_china_also_uses_paddle');
  var cardlessTrialEnabled = featureEnabled('rubriq_cardless_free_trial');
  // A cancelled plan has lost access and should see all available plans (same as an
  // expired plan), so only a genuinely active premium plan counts as "active" here.
  var hasActivePlan = curieSubscription.plan.status === 'active' && curieSubscription.plan.planType === 'premium';

  // Curie has its own actions for add/remove preferred group, but doing that when using the PreferredGroupWidget requires this
  var wrappedAction = function wrappedAction(fn) {
    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return new Promise(function (resolve) {
        return resolve(dispatch(fn.apply(void 0, args)));
      });
    };
  };
  var displayAvailablePlans = showPlans || Object.keys(curieSubscription.plans).length === 0;
  var usesChinaCartCheckout = chinaLocalization && !paddleBillingForChina;
  var showRowPricingPage = displayAvailablePlans && newRowPlans && !usesChinaCartCheckout;
  var showChinaPricingPage = displayAvailablePlans && usesChinaCartCheckout;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IdentifyPage, {
    title: "My Plan"
  }), showRowPricingPage && /*#__PURE__*/React.createElement(RowPricingPage, {
    hasActivePlan: hasActivePlan
  }), showChinaPricingPage && /*#__PURE__*/React.createElement(ChinaPricingPage, {
    hasActivePlan: hasActivePlan,
    freeTrialExpiration: curieSubscription.plan.freeTrialExpiration
  }), !showRowPricingPage && !showChinaPricingPage && /*#__PURE__*/React.createElement(PageSection, {
    header: t(displayAvailablePlans ? 'curie.available-plans' : 'curie.my-plan'),
    className: "new-rubriq-subscriptions g-padding",
    sub: displayAvailablePlans
  }, displayAvailablePlans ? /*#__PURE__*/React.createElement(PhasingOutAvailablePlans, {
    availablePlans: curieSubscription.plan.availablePlans,
    freeTrialExpiration: curieSubscription.plan.freeTrialExpiration,
    hasActivePlan: hasActivePlan
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PlanPagePaymentRecoveryBanner, null), /*#__PURE__*/React.createElement(RubriqNotificationBox, null), /*#__PURE__*/React.createElement("div", {
    className: "mb-3"
  }, Object.values(curieSubscription.plans).map(function (plan) {
    return /*#__PURE__*/React.createElement("div", {
      className: "col-12 mb-4",
      key: "plan-".concat(plan.type)
    }, /*#__PURE__*/React.createElement(PlanCard, {
      plan: _objectSpread(_objectSpread({}, plan), {}, {
        // TODO: This won't be needed once we add paddle data to `plans`.
        // Currently, it's only included in our legacy code and not in our `plans` object so this is adding it to paddle plans
        grantedFrom: _objectSpread(_objectSpread({}, plan.grantedFrom), plan.grantedFrom.grantingMechanism === 'paddle' && {
          paddleSubscription: curieSubscription.plan.paddleSubscription,
          subscriptionInterval: curieSubscription.plan.subscriptionInterval
        })
      })
    }));
  })))), /*#__PURE__*/React.createElement(PageSection, {
    header: t('curie.billing-history'),
    className: "rubriq-billing-history"
  }, !showPlans && curieSubscription.plan.planType === 'premium' && ((_curieSubscription$pl3 = curieSubscription.plan) === null || _curieSubscription$pl3 === void 0 ? void 0 : _curieSubscription$pl3.billingHistory) && /*#__PURE__*/React.createElement(RubriqBillingHistory, {
    billingHistory: (_curieSubscription$pl4 = curieSubscription.plan) === null || _curieSubscription$pl4 === void 0 ? void 0 : _curieSubscription$pl4.billingHistory
  })), /*#__PURE__*/React.createElement(PageSection, {
    header: t('curie.more-options'),
    className: "curie-more-options g-padding"
  }, !user.preferredGroup && /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12 col-md-4 mb-3"
  }, /*#__PURE__*/React.createElement(PreferredGroupWidget, {
    addPreferredGroup: wrappedAction(addPreferredGroup),
    removePreferredGroup: wrappedAction(removePreferredGroup),
    companyShortName: application.companyShortName,
    currency: user.currency,
    preferredGroup: user && user.preferredGroup ? user.preferredGroup : null,
    userIdentity: user.identity
  })), !displayAvailablePlans && (inPreferredGroupOnly || curieSubscription.plan.planType === 'free_trial') && /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12 col-md-4 mb-3"
  }, /*#__PURE__*/React.createElement(OptionCard, {
    title: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      className: "me-2",
      icon: "fa-solid fa-circle-arrow-up"
    }), /*#__PURE__*/React.createElement(T, {
      source: inPreferredGroupOnly ? 'curie.more-plans-card-title' : 'curie.upgrade-to-premium-title'
    })),
    message: /*#__PURE__*/React.createElement(T, {
      source: inPreferredGroupOnly ? 'curie.more-plans-card-message' : 'curie.upgrade-to-premium-message'
    }),
    button: /*#__PURE__*/React.createElement(Link, {
      className: "text-white text-uppercase",
      to: "/rubriq/plan/subscribe"
    }, /*#__PURE__*/React.createElement(T, {
      source: "curie.view-plans"
    }))
  }))), /*#__PURE__*/React.createElement(ModalError, null));
};
export default Subscriptions;